<template>
  <div class="widget-options">
    <q-btn
      v-if="!noDrag"
      class="drag-handle text-white"
      round
      size="7px"
      icon="fas fa-arrows"
      style="background: #b3b3b3"
    >
      <LmTooltip> Drag and drop the box to another location </LmTooltip>
    </q-btn>
    <q-btn v-if="allowResize" class="text-white" round size="7px" icon="fas fa-arrows-h" style="background: #b3b3b3">
      <q-menu>
        <q-list separator highlight>
          <q-item
            v-for="col of columns"
            :key="`${uid}_${col.label}`"
            v-close-popup
            clickable
            @click.native="$emit('select-width', { value: col.value, index: targetIndex })"
          >
            <q-item-label class="self-center">
              <q-item-section>{{ col.label }}</q-item-section>
            </q-item-label>
          </q-item>
        </q-list>
      </q-menu>
      <LmTooltip> Change box width </LmTooltip>
    </q-btn>
    <q-btn v-if="options.length" class="text-white" round size="7px" icon="fas fa-cog" style="background: #b3b3b3">
      <LmTooltip> Choose box content <span v-if="allowDelete">or delete box</span> </LmTooltip>
      <q-menu>
        <q-list>
          <template v-for="option of options">
            <q-item
              v-if="option.enabled"
              :key="`${uid}_${option.value}`"
              v-close-popup
              clickable
              @click="
                $emit('select-option', {
                  value: option.value,
                  index: targetIndex,
                  name: option.label
                })
              "
            >
              <q-item-label class="self-center">
                <q-item-section>{{ option.label }}</q-item-section>
              </q-item-label>
            </q-item>
          </template>
          <q-separator />
          <q-item
            v-if="allowDelete"
            :key="`${uid}_delete`"
            v-close-popup
            clickable
            @click="$emit('delete', targetIndex)"
          >
            <q-item-label class="self-center">
              <q-item-section>Delete box</q-item-section>
            </q-item-label>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
  </div>
</template>

<script>
import { uid } from 'quasar'
import { get } from 'lodash'

export default {
  name: 'WidgetOptions',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    targetIndex: {
      type: Number,
      required: true
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
    allowMove: {
      type: Boolean,
      default: true
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
    allowResize: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: false
    },
    component: {
      type: [Object, null],
      default: null
    },
    noDrag: Boolean
  },
  data() {
    return {
      uid: uid(),
      columns: [
        { value: 4, label: 'One third' },
        { value: 6, label: 'One half' },
        { value: 8, label: 'Two thirds' },
        { value: 12, label: 'Full width' }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.widget-options {
  display grid
  grid-auto-flow column
  grid-gap 5px
  margin-left 5px
  align-items end
}
.q-list {
   font-family 'Barlow', sans-serif
   font-size 12px
   font-weight 300
 }
.q-item {
  min-height 30px
}
</style>
